import { Box, Heading } from '@chakra-ui/react';
import { fontSize } from '@constants/styles';

const BlueBoxSlogan = () => {
  return (
    <Box bg="blue.400" borderRadius="10px">
      <Heading fontSize={fontSize.h1} p="10%" color="white" textAlign="center">
        The Medicare advisor I wish my parents had.
      </Heading>
    </Box>
  );
};

export default BlueBoxSlogan;
